import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';
Vue.use(VueLoaders);

import Embed from 'v-video-embed'
Vue.use(Embed);

import MarqueeText from 'vue-marquee-text-component'
Vue.component('marquee-text', MarqueeText)

var AddToCalendar = require('vue-add-to-calendar');
Vue.use(AddToCalendar);

import Popup from './components/Popup'
Vue.component('popup',Popup);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
